import React, { useState, useContext } from "react"; 
import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { sendStandardToast } from "../../toasts/standard-toast"
import { FormattedMessage } from "react-intl"
import { faMagic } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import { OverlayTrigger, Tooltip } from "react-bootstrap"; 
import { WingsModal } from "@wingspans-ui"
import { FirebaseContext } from "../../Firebase"
import './optimizer-button.css'


export default function OptimizerButton({ type, text, updateData, tense = "past" }) {
  const [showModal, setShowModal] = useState(false)
  const [optimizedBullets, setOptimizedBullets] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { firebase } = useContext(FirebaseContext)

  const fetchOptimizedText = async (text, e) => {

    e.stopPropagation()

    if (!text || text.trim() === "" || text.length < 5) {
      sendStandardToast({
        message: (
          <>
            <div>Please ensure text is at least 20 characters long</div>
          </>
        ),
        heading: <FormattedMessage id="resume-text-optimizer-modal-message-requirement" defaultMessage="AI Optimizer" />,
      })

      return
    }


    setIsLoading(true)

    try {
      const response = await firebase.optimizeText(text, type, tense)
      const optimized = response.optimized
      setOptimizedBullets(optimized)
      setShowModal(true)
    } catch (error) {
      console.error("Error fetching optimized bullets:", error)
    }
    setIsLoading(false) // End loading
  }

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props} >
      <FormattedMessage id="resume-use-ai-to-optimize-bullet" defaultMessage="Use AI to optimize your bullet" />
    </Tooltip>
  )

  const selectBullet = (bullet) => {
    setShowModal(false)
    updateData({ target: { value: bullet } })
  }
  return (
    <div className='resume-optimizer'>
      <OverlayTrigger placement="top" overlay={renderTooltip}>
        <button
          onClick={!isLoading ? (e) => fetchOptimizedText(text, e) : null}
          className='optimizer-button'
          style={{pointerEvents: isLoading ? "none" : "auto"}}
        >
          {isLoading ? (
            <FontAwesomeIcon icon={faSpinner} spin size="1x" color="#75C6D8" />
          ) : (
            <FontAwesomeIcon icon={faMagic} size="1x" color="#75C6D8" />
          )}
        </button>
      </OverlayTrigger>
      <WingsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        size="lg"
        className="optimizer-modal"
        title={<FormattedMessage id="resume-optimizer-choose-option" defaultMessage="Choose an Option" />}
        titleLevel={5}
      >
        <WingsModal.Body>
          <p className="optimizer-modal-description">
            <FormattedMessage id="resume-use-ai-to-optimize-text" defaultMessage="Use AI to optimize your text." />
          </p>
          <div className="optimizer-modal-list">
            {optimizedBullets.map((bullet, idx) => (
              <button
                key={idx}
                type="button"
                className="optimizer-modal-option"
                onClick={() => selectBullet(bullet)}
              >
                {bullet}
              </button>
            ))}
          </div>
        </WingsModal.Body>
      </WingsModal>
    </div>
  )
}
